<div class="row mt-2">
    <div class="col-md-3">
      <div class="card">
          <div class="card-header">
              <div class="card-title mb-0"><strong>Games Banner</strong></div>
          </div>
          <div class="card-body">
              <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Title <em>*</em></label>
                            <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.title" required>
                            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                                <div *ngIf="name.errors.required">Name is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Image <em>*</em></label>
                            <input type="file" (change)="loadFile($event)" class="form-control" id="image" name="image">
                            <div *ngIf="f.submitted && !data.image" class="invalid-feedback">
                                <div>Image is required</div>
                            </div>
                            <div *ngIf="data.image">
                                <img [src]="data.image" class="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="status" class="form-label">Category <em>*</em></label>
                            <select class="form-control" id="category_id" name="category_id" #category_id="ngModel" [(ngModel)]="data.category_id" required>
                                <option [value]="t.id" *ngFor="let t of initData.category">{{t.title}}</option>
                            </select>
                            <div *ngIf="f.submitted && category_id.invalid" class="invalid-feedback">
                                <div *ngIf="category_id.errors.required">Category is required</div>
                            </div>
                        </div>
                    </div>
                </div>  
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="status" class="form-label">Game <em>*</em></label>
                            <select class="form-control" id="game_id" name="game_id" #game_id="ngModel" [(ngModel)]="data.game_id" required>
                                <option [value]="t.id" *ngFor="let t of initData.games">{{t.title}}</option>
                            </select>
                            <div *ngIf="f.submitted && game_id.invalid" class="invalid-feedback">
                                <div *ngIf="game_id.errors.required">Game is required</div>
                            </div>
                        </div>
                    </div>
                </div>  
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="status" class="form-label">Game Integration <em>*</em></label>
                            <select class="form-control" id="integration_id" name="integration_id" #integration_id="ngModel" [(ngModel)]="data.integration_id" (change)="updateIntegration()" required>
                                <option [value]="'manual'">Manual</option>
                                <option [value]="t.id" *ngFor="let t of initData.integration">{{t.provider}}</option>
                            </select>
                            <div *ngIf="f.submitted && integration_id.invalid" class="invalid-feedback">
                                <div *ngIf="integration_id.errors.required">Integration is required</div>
                            </div>
                        </div>
                        <div class="mb-3" *ngIf="data.integration_id && data.integration_id != 'manual'">
                            <div class="form-check" *ngFor="let t of gamesCode; let i = index">
                                <input class="form-check-input" [id]="'ic' + i" [name]="'ic' + i" type="radio" [value]="t.code+'_'+t.type" [(ngModel)]="data.game_code" />
                                <label class="form-check-label" [for]="'ic' + i">
                                    {{t.title}}
                                </label>
                            </div>
                            <div *ngIf="f.submitted && !data.game_code" class="invalid-feedback">
                                <div>Integration game code is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Sort</label>
                            <input type="number" class="form-control" id="sort" name="sort" #sort="ngModel" [(ngModel)]="data.sort">
                        </div>
                    </div>
                </div>
                <div class="row">
                      <div class="col-12">
                          <div class="mb-3">
                              <label for="status" class="form-label">Status <em>*</em></label>
                              <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                                  <option [value]="1">Active</option>
                                  <option [value]="0">Disabled</option>
                              </select>
                              <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                  <div *ngIf="status.errors.required">Status is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <button type="submit" class="btn btn-primary">Update</button>
              </form>
          </div>
      </div>
    </div>
  </div>